<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>邮件{{ formData.id > 0 ? '编辑' : '新增' }}</span>
        </div>
        <el-form ref="formData" :rules="rules" :model="formData" label-width="80px">
          <el-form-item label="时间范围">
            <el-form-item label="开始时间" prop="start_time">
              <el-date-picker v-model="formData.start_time" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 400px" placeholder="开始时间" />
            </el-form-item>
            <el-form-item style="margin-top: 15px" label="结束时间" prop="end_time">
              <el-date-picker v-model="formData.end_time" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 400px" placeholder="结束时间" />
            </el-form-item>
          </el-form-item>
          <el-form-item label="在线范围">
            <el-form-item label="开始时间" prop="online_start">
              <el-date-picker v-model="formData.online_start" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 400px" placeholder="开始时间" />
            </el-form-item>
            <el-form-item style="margin-top: 15px" label="结束时间" prop="online_end">
              <el-date-picker v-model="formData.online_end" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 400px" placeholder="结束时间" />
            </el-form-item>
          </el-form-item>
          <el-form-item label="等级范围">
            <el-form-item label="开始等级" prop="level_start">
              <el-input v-model="formData.level_start" style="width: 400px" placeholder="开始等级" />
            </el-form-item>
            <el-form-item style="margin-top: 15px" label="结束等级" prop="level_end">
              <el-input v-model="formData.level_end" style="width: 400px" placeholder="结束等级" />
            </el-form-item>
          </el-form-item>
          <el-form-item label="积分范围">
            <el-form-item label="开始积分" prop="score_start">
              <el-input v-model="formData.score_start" style="width: 400px" placeholder="开始积分" />
            </el-form-item>
            <el-form-item style="margin-top: 15px" label="结束积分" prop="score_end">
              <el-input v-model="formData.score_end" style="width: 400px" placeholder="结束积分" />
            </el-form-item>
          </el-form-item>
          <el-form-item label="显示天数" prop="days">
            <el-input v-model.number="formData.days" style="width: 400px" placeholder="显示天数" />
          </el-form-item>
          <el-form-item label="版本" prop="version">
            <el-select v-model="formData.version" multiple placeholder="请选择" style="width: 800px">
              <el-option
                v-for="item in versionData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="设备类型" prop="sid">
            <el-select v-model.number="formData.sid" style="width: 400px" placeholder="请选择">
              <el-option
                v-for="(item, index) in sidType"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="用户" prop="uids">
            <el-input v-model="formData.uids" placeholder="请输入用户ID,以逗号分隔" />
          </el-form-item>
          <el-form-item label="语言" prop="langs">
            <el-select v-model="formData.langs" style="width: 800px" multiple placeholder="请选择">
              <el-option
                v-for="(item, index) in lang"
                :key="index"
                :label="item"
                :value="index"
              />
            </el-select>
            <el-upload
              ref="upload"
              style="display: inline-block"
              class="upload-demo"
              :action="sys_app_logoAction"
              accept="xlsx"
              :limit="1"
              :on-success="(res)=>{return importUploadSuccess(res)}"
              :headers="headers"
            >
              <el-button style="margin-left: 10px" :loading="loading" icon="el-icon-upload2" type="primary">导入</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item prop="title">
            <el-form :inline="true">
              <el-row v-for="(l, li) in formData.langs" :key="li">
                <el-form-item :label="lang[l]+': 标题'" style="margin-top: 8px;">
                  <el-input v-model="formData.title[l]" style="width: 480px;" :placeholder="lang[l]+': 标题'" />
                </el-form-item>
                <el-form-item label="内容" style="margin-top: 8px;">
                  <el-input v-model="formData.body[l]" type="textarea" :rows="3" placeholder="请输入内容" style="width: 480px;" />
                </el-form-item>
              </el-row>
            </el-form>
          </el-form-item>
          <el-form-item label="奖励" prop="rewards">
            <Reward :value="formData.rewards" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
            <el-button>取消</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getRewardType } from '@/api/config/slot'
import { updateMailCfg } from '@/api/config/mail-cfg'
// import { searchUid } from '@/api/user/user_info'
import { getMailCfgList } from '@/api/config/email-cfg'
import { importGameUpdateLang } from '@/api/config/game-update-cfg'
import { geVersiontCfg } from '@/api/config/version-set'
import Reward from '@/components/Reward/index.vue'
import { getToken } from '@/utils/auth'

export default {
  name: 'EmailEdit',
  components: { Reward },
  data() {
    return {
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      versionData: [],
      rewardType: [],
      total: 0,
      sidType: [
        { label: '全部', value: 0 },
        { label: '安卓', value: 1 },
        { label: 'IOS', value: 2 }
      ],

      lang: {
        'EN': '英 文',
        'ZH': '中 文',
        'DE': '德 语',
        'FR': '法 语',
        'ID': '印 尼',
        'NO': '挪 威',
        'RO': '罗马尼亚语',
        'TW': '繁 体',
        'VI': '越 南',
        'TH': '泰 语',
        'MY': '马来语',
        'IT': '意大利语',
        'ES': '西班牙',
        'PT': '葡萄牙',
        'PL': '波 兰',
        'JP': '日 语',
        'KR': '韩 语',
        'RU': '俄 语',
        'AR': '阿拉伯'
      },
      loading: false,
      formData:
        {
          'id': 0,
          'online_start': '',
          'online_end': '',
          'start_time': '',
          'end_time': '',
          'level_start': 0,
          'level_end': 0,
          'score_start': 0,
          'score_end': 0,
          'sid': 1,
          'langs': [],
          'title': {},
          'body': {},
          'rewards': [],
          'days': 0,
          'uids': '',
          'version': '',
          'type': 0
        },
      rules: {
        // online_start: [
        //   { type: 'string', required: true, message: '请输入在线开始时间', trigger: 'blur' }
        // ],
        // online_end: [
        //   { type: 'string', required: true, message: '请输入在线结束时间', trigger: 'blur' }
        // ],
        // start_time: [
        //   { type: 'string', required: true, message: '请输入开始时间', trigger: 'change' }
        // ],
        // end_time: [
        //   { type: 'string', required: true, message: '请输入结束时间', trigger: 'blur' }
        // ],
        level_start: [
          { required: true, message: '请输入开始等级', trigger: 'blur' }
        ],
        level_end: [
          { required: true, message: '请输入结束等级', trigger: 'blur' }
        ],
        // score_start: [
        //   { required: true, message: '请输入开始积分', trigger: 'blur' }
        // ],
        // score_end: [
        //   { required: true, message: '请输入结束积分', trigger: 'blur' }
        // ],
        langs: [
          { type: 'array', required: true, message: '请输入语言', trigger: 'change' }
        ],
        // version: [
        //   { required: true, message: '请输入版本', trigger: 'blur' }
        // ],
        days: [
          { required: true, message: '请输入显示天数', trigger: 'blur' }
        ]
        // rewards: [
        //   { type: 'array', required: true, message: '请输入奖励', trigger: 'blur' }
        // ]
        // title: [
        //   { type: 'array', required: true, message: '请输入标题', trigger: 'blur' }
        // ],
        // body: [
        //   { type: 'array', required: true, message: '请输入内容', trigger: 'blur' }
        // ]

      }
    }
  },
  created() {
    this.getVersion()
    const id = this.$route.query.id
    this.formData.type = parseInt(this.$route.query.type)
    if (id > 0) {
      this.getTables(id)
    }
    this.getRewardTypeData()
  },
  methods: {
    getVersion() {
      geVersiontCfg().then(res => {
        if (res.code === 200) {
          res.data.forEach(item => {
            this.versionData.push({ label: item, value: item })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importUploadSuccess(response) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importGameUpdateLang({ data: response.data.path }).then(res => {
        this.loading = false
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.formData.langs = res.data.lang
          this.formData.title = res.data.title
          this.formData.body = res.data.body
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables(id) {
      getMailCfgList({ id: id, type: this.formData.type }).then(res => {
        if (res.code === 200) {
          this.formData = res.data.list[0]
        } else {
          this.msgError(res.msg)
        }
      })
    },
    onSubmit() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          if (this.formData.level_start > this.formData.level_end) {
            this.msgError('最低等级不能大于最高等级')
            return
          }
          if (this.formData.score_start > this.formData.score_end) {
            this.msgError('最低积分不能大于最高积分')
            return
          }

          if (this.formData.online_start > this.formData.online_end) {
            this.msgError('在线范围：开始时间不能大于在线结束时间')
            return
          }

          if (this.formData.start_time > this.formData.end_time) {
            this.msgError('时间范围：开始时间不能大于结束时间')
            return
          }
          if (this.formData.langs.length > 0) {
            for (const i in this.formData.langs) {
              const _lang = this.formData.langs[i]
              const _title = this.formData.title[_lang]
              if (_title === '' || _title === undefined) {
                this.msgError('标题 ' + this.lang[_lang] + ' 不能为空')
                return
              }
            }

            for (const i in this.formData.langs) {
              const _lang = this.formData.langs[i]
              const _content = this.formData.body[_lang]
              if (_content === '' || _content === undefined) {
                this.msgError('内容 ' + this.lang[_lang] + ' 不能为空')
                return
              }
            }
          }
          // 格式化
          // this.formData.start_time = this.dateFormat(this.formData.start_time)
          // this.formData.end_time = this.dateFormat(this.formData.end_time)
          // this.formData.online_start = this.dateFormat(this.formData.online_start)
          // this.formData.online_end = this.dateFormat(this.formData.online_end)

          // console.log(JSON.stringify(this.formData.online_start))
          const formData = JSON.parse(JSON.stringify(this.formData))
          if (formData.uids) {
            formData.uids = formData.uids.split(',').map(s => s.trim()).filter(s => s)
          }
          const data = JSON.stringify(formData)
          console.log(data)
          updateMailCfg({ data: data }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              let path = '/config/sys-email/list'
              if (this.formData.type) {
                path = '/config/sys-email/template'
              }
              this.$router.push({ path: path })
            } else {
              this.msgError(res.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    addReward() {
      this.formData.rewards.push({
        propsId: 14,
        skin: 0,
        num: 0,
        rtype: 1
      })
    },
    removeReward(i) {
      this.formData.rewards = this.formData.rewards.filter((item, key) => {
        return i !== key
      })
    },
    dateFormat(d) {
      const dateObject = new Date(d)
      const year = dateObject.getFullYear()
      const month = String(dateObject.getMonth() + 1).padStart(2, '0')
      const day = String(dateObject.getDate()).padStart(2, '0')
      const hours = String(dateObject.getHours()).padStart(2, '0')
      const minutes = String(dateObject.getMinutes()).padStart(2, '0')
      const seconds = String(dateObject.getSeconds()).padStart(2, '0')

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style scoped>
</style>
